import dashboardIconDefault from '@/icons/fontawesome/display-chart-up-classic-solid.svg';
import walletIconDefault from '@/icons/fontawesome/wallet-classic-solid.svg';
import rewardsIconDefault from '@/icons/fontawesome/hand-holding-star-classic-solid.svg';
import nodesIconDefault from '@/icons/fontawesome/circle-nodes-classic-solid.svg';
import nftIconDefault from '@/icons/fontawesome/hexagon-image-classic-solid.svg';
import apple from '@/icons/logos/apple.svg';
import linux from '@/icons/logos/linux.svg';
import vps from '@/icons/fontawesome/display-solid.svg';
import { brand } from '@/brand/brand';

// Use brand-specific icons if available, otherwise use defaults
const dashboardIcon = brand.navbarIcons?.dashboard
  ? { src: brand.navbarIcons.dashboard }
  : dashboardIconDefault;
const walletIcon = brand.navbarIcons?.wallet
  ? { src: brand.navbarIcons.wallet }
  : walletIconDefault;
const rewardsIcon = brand.navbarIcons?.rewards
  ? { src: brand.navbarIcons.rewards }
  : rewardsIconDefault;
const nodesIcon = brand.navbarIcons?.nodes
  ? { src: brand.navbarIcons.nodes }
  : nodesIconDefault;

const nftIcon = brand.navbarIcons?.nfts
  ? { src: brand.navbarIcons.nfts }
  : nftIconDefault;

const nodesSetupRoutes = {
  mac: {
    path: '/dashboard/nodes/mac',
    key: 'mac',
    value: 'macOS',
    icon: apple.src,
  },
  linux: {
    path: '/dashboard/nodes/linux',
    key: 'linux',
    value: 'Linux',
    icon: linux.src,
  },
  vps: {
    path: '/dashboard/nodes/vps',
    key: 'vps',
    value: 'VPS',
    icon: vps.src,
  },
};

export const dashboardRoutes = {
  ...nodesSetupRoutes,
  dashboard: {
    key: 'dashboard',
    value: 'Dashboard',
    icon: dashboardIcon.src,
  },
  nodes: {
    path: '/dashboard/nodes',
    key: 'nodes',
    value: 'Nodes',
    icon: nodesIcon.src,
  },
  rewards: {
    path: '/dashboard/rewards',
    key: 'rewards',
    value: 'Rewards',
    icon: rewardsIcon.src,
  },
  wallet: {
    path: '/dashboard/wallet',
    key: 'wallet',
    value: 'Wallet',
    icon: walletIcon.src,
  },
  nfts: {
    path: '/dashboard/wallet/nfts',
    key: 'nfts',
    value: 'NFTs',
    icon: nftIcon.src,
  },
  walletMigration: {
    path: '/dashboard/wallet/wallet-migration',
    key: 'wallet-migration',
    value: 'Wallet Migration',
  },
  forgotMnemonic: {
    path: '/dashboard/wallet/forgot-mnemonic',
    key: 'forgot-mnemonic',
    value: 'Forgot Mnemonic',
  },
  setupWallet: {
    path: '/dashboard/wallet/setup-wallet',
    key: 'setup-wallet',
    value: 'Setup wallet',
  },
};
